import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
  }

  static targets = [
    "contactRolesContainer",
    "template"
  ]

  connect() {
    console.log('connect');
  }

  disconnect() {
  }

  add(event) {
    console.log('add');
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.contactRolesContainerTarget.insertAdjacentHTML('beforeend', content);
    const newElement = this.contactRolesContainerTarget.lastElementChild;
    const firstInput = newElement.querySelector('input');
    if (firstInput) {
      firstInput.focus();
    }
    event.preventDefault();
    return false;
  }
}
